import React from 'react';
import { Dialog, Grid, Button, Divider, TextField, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers';
import HSRestManager from '../../utils/api-controllers/third-party/hubspot/HSRestManager';
import SFRestManager from '../../utils/api-controllers/third-party/salesforce/SFRestManager';
import CustomSnackbar from '../CustomSnackbar';
import moment from 'moment';

class CRMBulkPopover extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            taskStatus: '',
            taskDetails: '',
            taskSubject: '',
            taskDate: new Date(),
            statusList: [
                {
                  key: 'NOT_STARTED',
                  value: 'Not Started',
                },
                {
                  key: 'IN_PROGRESS',
                  value: 'In Progress',
                },
                {
                  key: 'COMPLETED',
                  value: 'Completed',
                },
                {
                  key: 'WAITING',
                  value: 'Waiting on someone else',
                },
                {
                  key: 'DEFERRED',
                  value: 'Deferred',
                },
            ],
            accessToken: null,
            openSnackbar: false,
            message: '',
            messageType: '',
        };
    }

    handleClose = () => {
        this.setState({
            taskStatus: '',
            taskDate: new Date(),
            taskSubject: '',
            taskDetails: ''
        });
        this.props.onClose();
    }

    handleSnackbarClose = () => {
        this.setState({ openSnackbar: false });
    }

    textFieldChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    dateChange = date => {
        this.setState({ taskDate: date });
    }

    bulkCreateTasks = () => {
        const { client } = this.props;
        const refreshToken = client.refresh_token;
        if(client.connected_with == "Hubspot"){
            HSRestManager.getAccessTokenFromRefreshToken(
                refreshToken,
                "",
                "",
                "",
                "",
                this.HSAccessTokenForTasksSuccess,
                this.HSAccessTokenForTasksFailure,
            );
        } else if(client.connected_with == "Salesforce"){
            SFRestManager.getAccessTokenFromRefreshToken(
                refreshToken,
                "",
                "",
                "",
                "",
                this.SFAccessTokenForTasksSuccess,
                this.SFAccessTokenForTasksFailure,
            );
        }
    }

    HSAccessTokenForTasksSuccess = (response) => {
        if(response.data){
            const accessToken = response.data.access_token;
            this.setState({ accessToken: accessToken });
            const { guests } = this.props;
            let emails = guests.map(g => `email=${g.guest_email}`);
            let params = emails.join("&");
            
            HSRestManager.getClientIds(
                accessToken,
                'https://api.hubapi.com',
                params,
                this.HSClientIdsSuccess,
                this.HSClientIdsFailure,
            );
        }
    }

    HSAccessTokenForTasksFailure = error => {
        let message = "Failed to get refresh token for Hubspot";
        if(error && error.message){
            message += " : " + error.message;
        }
        this.props.onClose();
        this.setState({
            openSnackbar: true,
            messageType: "Error",
            message: message,
        });
    }

    SFAccessTokenForTasksSuccess = (response) => {
        const { guests, salesforce_instance_url, client } = this.props;
        if(response.data){
            const { access_token } = response.data;
            const taskData = {
                'ActivityDate': moment(this.state.taskDate).toDate().getTime(),
                'ActivityDateSpecified': true,
                'Description': this.state.taskDetails,
                'IsRecurrence': false,
                'Status': this.state.taskStatus,
                'Subject': this.state.taskSubject,
                'Type': 'Lead',
            }

            SFRestManager.createBulkTask(
                access_token,
                salesforce_instance_url,
                taskData,
                guests,
                this.SFCreateBulkTaskSuccess,
                this.SFCreateBulkTaskFailure,
            )
        }
    }

    SFAccessTokenForTasksFailure = (error) => {
        let message = "Failed to get refresh token for Salesforce";
        if(error && error.message){
            message += " : " + error.message;
        }
        this.props.onClose();
        this.setState({
            openSnackbar: true,
            messageType: "Error",
            message: message,
        });
    }

    HSClientIdsSuccess = (response) => {
        if(response.data){
            const contactIds = Object.keys(response.data);
            if(contactIds && contactIds.length){
                const accessToken = this.state.accessToken;
                const task = {
                    subject: this.state.taskSubject,
                    details: this.state.taskDetails,
                    status: this.state.taskStatus,
                    date: moment(this.state.taskDate).toDate().getTime()
                }
                HSRestManager.createBulkTask(
                    accessToken,
                    'https://api.hubapi.com',
                    contactIds,
                    task,
                    this.HSCreateBulkTaskSuccess,
                    this.HSCreateBulkTaskFailure,
                );
            }
        }
    }

    HSClientIdsFailure = error => {
        let message = "Failed to get client ids of the guests on Hubspot";
        if(error && error.message){
            message += " : " + error.message;
        }
        this.props.onClose();
        this.setState({
            openSnackbar: true,
            messageType: "Error",
            message: message,
        });
    }

    HSCreateBulkTaskSuccess = (response) => {
        if(response.status == 200){
            this.props.onClose();
            this.setState({
                openSnackbar: true,
                messageType: "Success",
                message: "Successfully created tasks on Hubspot!",
                taskStatus: '',
                taskDate: new Date(),
                taskSubject: '',
                taskDetails: ''
            });
        }
    }

    HSCreateBulkTaskFailure = error => {
        this.props.onClose();
        this.setState({
            openSnackbar: true,
            messageType: "Error",
            message: "Failed to create tasks on Hubspot.",
            taskStatus: '',
            taskDate: new Date(),
            taskSubject: '',
            taskDetails: ''
        });
    }

    SFCreateBulkTaskSuccess = (response) => {
        if(response && response.status == 200){
            this.props.onClose();
            this.setState({
                openSnackbar: true,
                messageType: "Success",
                message: "Successfully created tasks on Salesforce!",
                taskStatus: '',
                taskDate: new Date(),
                taskSubject: '',
                taskDetails: ''
            });
        } else if(response && response.status == 400){
            let message = "Failed to create tasks on Salesforce";
            if(response.errors){
                message += " : Create lead first for " + response.errors.join(",");
            }
            this.props.onClose();
            this.setState({
                openSnackbar: true,
                messageType: "Error",
                message: message,
                taskStatus: '',
                taskDate: new Date(),
                taskSubject: '',
                taskDetails: ''
            });
        }
    }

    SFCreateBulkTaskFailure = error => {
        this.props.onClose();
        this.setState({
            openSnackbar: true,
            messageType: "Error",
            message: "Failed to create tasks on Salesforce",
            taskStatus: '',
            taskDate: new Date(),
            taskSubject: '',
            taskDetails: ''
        });
    }

    bulkCreateLeads = () => {
        const { client } = this.props;
        const refreshToken = client.refresh_token;
        if(client.connected_with == "Hubspot"){
            HSRestManager.getAccessTokenFromRefreshToken(
                refreshToken,
                "",
                "",
                "",
                "",
                this.HSAccessTokenFromRefreshSuccess,
                this.HSAccessTokenFromRefreshFailure,
            );
        } else if(client.connected_with == "Salesforce"){
            SFRestManager.getAccessTokenFromRefreshToken(
                refreshToken,
                "",
                "",
                "",
                "",
                this.SFAccessTokenFromRefreshSuccess,
                this.SFAccessTokenFromRefreshFailure,
            );
        }
    }

    HSAccessTokenFromRefreshSuccess = (response) => {
        const { guests, client } = this.props;
        let list = []
        if(response.data && guests && client){
            const accessToken = response.data.access_token;
            guests.forEach(guest => {
                let firstName = guest.guest_name;
                let lastName = '';
                if(guest.guest_name){
                    let split = guest.guest_name.split(" ");
                    if(split.length > 1){
                        firstName = split[0];
                        lastName = split[1];
                    }
                }
                let data = {
                    email: guest.guest_email,
                    properties: [
                        { property: 'email', value: guest.guest_email },
                        { property: 'firstname', value: firstName != '' ? firstName : '' },
                        { property: 'lastname', value: lastName },
                        { property: 'company', value: guest.guest_company_name },
                        { property: 'phone', value: guest.guest_phone_no },
                        { property: 'jobtitle', value: guest.guest_title },
                        { property: 'hs_lead_status', value: 'NEW' },
                        { property: 'lifecyclestage', value: 'lead'},
                    ]
                };
                if(client._id == 123){
                    // Custom property for TAXA Outdoors
                    let props = [...data.properties];
                    props.push({ property: 'offline_sources_detail', value: 'Best.Day.Ever' });
                    data.properties = props;
                }
                list.push(data);
            });

            HSRestManager.createBulkLead(
                accessToken,
                'https://api.hubapi.com',
                list,
                this.createHSBulkLeadSuccess,
                this.createHSBulkLeadFailure,
            );
        }
    }

    HSAccessTokenFromRefreshFailure = error => {
        let message = "Failed to get refresh token for Hubspot";
        if(error && error.message){
            message += " : " + error.message;
        }
        this.props.onClose();
        this.setState({
            openSnackbar: true,
            messageType: "Error",
            message: message,
        });
    }

    SFAccessTokenFromRefreshSuccess = response => {
        const { guests, salesforce_instance_url, client } = this.props;
        let list = [];
        if(response && response.data){
            const { access_token } = response.data;
            guests.forEach(guest => {
                let firstName = guest.guest_name;
                let lastName = '';
                if(guest.guest_name){
                    let split = guest.guest_name.split(" ");
                    if(split.length > 1){
                        firstName = split[0];
                        lastName = split[1];
                    }
                }
                let data = {
                    "FirstName": firstName,
                    "LastName": lastName,
                    "Company": guest.guest_company_name,
                    "Email": guest.guest_email,
                    "Title": guest.guest_title,
                    "Status": "Open - Not Contacted",
                };
                list.push(data);
            });

            SFRestManager.createBulkLead(
                access_token,
                salesforce_instance_url,
                list,
                this.createSFBulkLeadSuccess,
                this.createSFBulkLeadFailure,
            );
        }
    }

    SFAccessTokenFromRefreshFailure = error => {
        let message = "Failed to get refresh token for Salesforce";
        this.props.onClose();
        this.setState({
            openSnackbar: true,
            messageType: "Error",
            message: message,
        })
    }

    createHSBulkLeadSuccess = response => {
        if(response.status == 200){
            this.props.onClose();
            this.setState({
                openSnackbar: true,
                messageType: "Success",
                message: "Successfully created leads!"
            });
        }
    }

    createHSBulkLeadFailure = error => {
        let message = "Failed to create leads";
        if(error && error.message){
            if(error.invalidEmails) message += " : Invalid emails were found - " + error.invalidEmails.join(" ,");
            else message += " : " + error.message;
        }
        this.props.onClose();
        this.setState({
            openSnackbar: true,
            messageType: "Error",
            message: message,
        })
    }

    createSFBulkLeadSuccess = response => {
        if(response.data && response.data.status == 200){
            this.props.onClose();
            this.setState({
                openSnackbar: true,
                messageType: "Success",
                message: "Successfully created leads!"
            });
        } else if(response.data && response.data.status == 400){
            let message = "Failed to create leads";
            if(response.data.errors){
                let str = response.data.errors.join("/");
                this.props.onClose();
                this.setState({
                    openSnackbar: true,
                    messageType: "Error",
                    message: message + " : " + str,
                })
            }
        }
    }

    createSFBulkLeadFailure = error => {
        let message = "Failed to create leads";
        if(error && error.message) message += " : " + error.message;
        this.props.onClose();
        this.setState({
            openSnackbar: true,
            messageType: "Error",
            message: message,
        })
    }

    render(){
        const { open, client } = this.props;
        const logo = client && client.connected_with == "Hubspot" ? "/images/hubspot.png" : "/images/salesforce-view-icon.svg";

        return (
            <>
            <CustomSnackbar
                onClose={this.handleSnackbarClose}
                open={this.state.openSnackbar}
                type={this.state.messageType}
                message={this.state.message}
            />
            <Dialog
                maxWidth="md"
                fullWidth={true}
                onClose={this.handleClose}
                open={open}
            >
                <Grid container xs={12} sm={12} md={12} lg={12} style={{ padding: '15px 25px' }}>
                    <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginBottom: '10px' }}>
                        <img src={logo} width="125px" />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: '10px', marginBottom: '10px' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.bulkCreateLeads}
                        >
                            Create Lead For All Guests
                        </Button>
                    </Grid>
                    <Divider style={{ width: '100%', margin: '20px 0px' }} />
                    <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: '10px', marginBottom: '10px' }}>
                        <h4>Task Information</h4>
                        <TextField
                            required
                            fullWidth
                            label="Subject"
                            value={this.state.taskSubject}
                            name="taskSubject"
                            onChange={this.textFieldChange}
                            style={{marginBottom: '10px'}}
                        />
                        <TextField
                            required
                            fullWidth
                            label="Task Details"
                            value={this.state.taskDetails}
                            name="taskDetails"
                            onChange={this.textFieldChange}
                            multiline={true}
                            rows="3"
                            style={{marginBottom: '10px'}}
                        />
                        <FormControl style={{width: '100%', marginBottom: '10px'}}>
                            <InputLabel>Task Status</InputLabel>
                            <Select
                                required
                                label="Task Status"
                                value={this.state.taskStatus}
                                inputProps={{
                                    id: "taskStatus",
                                    name: "taskStatus",
                                }}
                                onChange={this.textFieldChange}
                            >
                            {
                                this.state.statusList &&
                                this.state.statusList.map((el, i) => {
                                    return (
                                        <MenuItem
                                            value={el.key}
                                            key={`status_${i}`}
                                        >
                                            {el.value}
                                        </MenuItem>
                                    )
                                })
                            }
                            </Select>
                        </FormControl>
                        <KeyboardDatePicker
                            fullWidth
                            variant="inline"
                            format={"MM/DD/YYYY"}
                            id="taskDate"
                            label="Due Date"
                            value={this.state.taskDate}
                            onChange={this.dateChange}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: '10px', marginBottom: '10px' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.bulkCreateTasks}
                        >
                            Create Task For All Guests
                        </Button>
                    </Grid>
                </Grid>
            </Dialog>
            </>
        )
    }
}

export default CRMBulkPopover;